export default __webpack_public_path__ + "static/media/liqueurdrinks.3ac43e96.png";